// extracted by mini-css-extract-plugin
export default {"searchIcon":"searchIcon---KhUsr","isFocused":"isFocused---rt8wo"};